import { generateApiClient } from '@guiker/rest-client'

import { AdminApi, AuthenticatedApi } from '../api-definition'
import { config } from '../config'

export const AuthApiClient = generateApiClient(config.apiName, AuthenticatedApi.routes)
export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
